namespace TabAurous.Production {
    export namespace MFGTransactionItemsService {
        export const baseUrl = 'Production/MFGTransactionItems';

        export declare function Update(request: Serenity.SaveRequest<MFGTransactionItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MFGTransactionItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MFGTransactionItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Production/MFGTransactionItems/Update",
            Delete = "Production/MFGTransactionItems/Delete",
            Retrieve = "Production/MFGTransactionItems/Retrieve",
            List = "Production/MFGTransactionItems/List"
        }

        [
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MFGTransactionItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
